import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
//  It is a accesdendid error popup component
const AccessDenied = () => {

  const navigate = useNavigate();

  useEffect(() => {
    const denied = sessionStorage.getItem("denied");


    if (!denied) {
      navigate('/')
    }
  }, [navigate])


  const handleLogin = () => {
    sessionStorage.removeItem("denied");
    navigate("/login")
  }

  return (


    <div className="fixed inset-0 bg-transparent bg-opacity-50 flex items-center justify-center">
      <div className="bg-white p-6 rounded text-center shadow-md">

        <h2 className="text-red-600 font-bold text-lg mb-2">Access Denied</h2>

        <p className='text-mytextlight'>Your dashboard is already active in another tab. Please log in again to continue.</p>


        <button
          onClick={handleLogin}
          className="bg-blue-400  border-gray-800 text-white px-4 py-2 rounded hover:bg-blue-600 "
        >
          Login
        </button>
      </div>
    </div>



  );

};

export default AccessDenied;